import { SERVICE_BANNER } from '../services';
import { useQuery } from '@tanstack/react-query';

export const useBanner = () => {
  return useQuery({
    queryKey: ['banner'],
    queryFn: SERVICE_BANNER.getBannerData,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

export const useBannerById = (id) => {
  return useQuery({
    queryKey: ['banner', { id }],
    queryFn: () => SERVICE_BANNER.getBannerById(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
